<template>
    <div class="game-header"
      v-bind:style="{'background-color': gameConfig.gameConfig[gameId].color}">
      <label >{{setGameName | translate}}</label>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import gameConfig from '@/config/gameConfig';

export default {
  name: 'GameHeader',
  data() {
    return {
      gameConfig: { gameConfig },
    };
  },
  computed: {
    ...mapGetters([
      'gameId',
    ]),
    setGameName() {
      let gameName = '';
      const game = this.gameId;
      switch (game) {
        case 'RushFootball2':
          gameName = 'game.RushFootball2';
          break;
        case 'SportradarVirtualFootball':
          gameName = 'game.SportradarVirtualFootball';
          break;
        // no default
      }
      return gameName;
    },
  },
};
</script>
